module.exports = {
  ConfigData : {
  "APP_ID": "dual-broker-staging",  
  "API_URL": "https://apim-dl-uat-integrationlayer-ne.azure-api.net/broker-registration/SendEmail",
  "OCP_APIM_SUBSCRIPTION_KEY": "5dbd96b8124c436c9db3c86902b5d542"
  }
}